<section class="scr-page scr-page--compact container-advertisement">
  <div class="scr-master-detail">
    <div class="head-list scr-card scr-card--padded">
      <tp-page-header
        variant="toolbar"
        class="tp-page-header--flat tp-page-header--stacked"
        title="Publicidades"
        [subtitle]="advertisements.length + (advertisements.length === 1 ? ' publicidad' : ' publicidades')"
      >
        <button mat-flat-button actions class="scr-btn-primary" type="button" (click)="cleanForm()">
          <mat-icon>add</mat-icon>
          Nueva publicidad
        </button>
      </tp-page-header>
      <div class="list">
        <div class="row advertisementListTitle text-left">
          <b>Publicidades</b>
        </div>
        <ul class="vehiculos scrollable-content">
          @for (advertisement of advertisements; track advertisement) {
            <li
              class="scr-list-item"
              [class.scr-list-item--selected]="isSelectedAdvertisement(advertisement)"
              [attr.aria-current]="isSelectedAdvertisement(advertisement) ? 'true' : null"
            >
              <div class="elem-row">
                <div
                  class="col-md-9 description"
                  style="cursor: pointer"
                  (click)="editAdvertisement(advertisement)"
                  >
                  <span>{{ advertisement.name }}</span>
                </div>
                <div class="col-md-2">
                  <span
                    ><b>{{
                    advertisement.isActive == true ? "Activa" : "Inactiva"
                  }}</b></span
                  >
                </div>
                <div class="col-1">
                  <mat-icon
                    (click)="deleteAdvertisement(advertisement)"
                    title="deleteAdvertisement"
                    class="align-self-center"
                    style="cursor: pointer; color: grey"
                    >delete_outlined
                  </mat-icon>
                </div>
              </div>
            </li>
          }
        </ul>
        @if (advertisements.length === 0) {
          <tp-empty-state
            icon="campaign"
            title="Todavía no hay publicidades"
            message="Creá la primera con «Nueva publicidad»."
          ></tp-empty-state>
        }
      </div>
    </div>
    <div class="form-container scr-card scr-card--padded">
      <div class="scr-detail-head">
        @if (!isNew()) {
          <h2 class="scr-section-title">Editando: {{ advertisementForm.controls.name.value }}</h2>
          <p class="scr-detail-head__sub">{{ advertisementForm.controls.link.value }}</p>
        } @else {
          <h2 class="scr-section-title">Elegí una publicidad de la lista</h2>
          <p class="scr-detail-head__sub">O completá los datos para crear una nueva.</p>
        }
      </div>
      <form [formGroup]="advertisementForm" class="ad-form">
        <div class="cf-grid">
          <div class="cf-field cf-field--full">
            <label class="cf-label" for="ad-name">Nombre *</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input id="ad-name" matInput placeholder="Nombre" name="name" formControlName="name" required />
              <mat-error>Ingresá el nombre.</mat-error>
            </mat-form-field>
          </div>
          <div class="cf-field cf-field--full">
            <label class="cf-label" for="ad-description">Descripción *</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <textarea
                id="ad-description"
                matInput
                matTextareaAutosize="5"
                type="text"
                placeholder="Descripción"
                name="description"
                formControlName="description"
                [rows]="4"
                required
              ></textarea>
              <mat-hint align="end">{{ advertisementForm.controls['description'].value?.length || 0 }}/{{ descriptionMaxLength }}</mat-hint>
              @if (advertisementForm.controls['description'].hasError('maxlength')) {
                <mat-error>La descripción no puede superar los {{ descriptionMaxLength }} caracteres.</mat-error>
              } @else {
                <mat-error>Ingresá la descripción.</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="cf-field cf-field--full">
            <label class="cf-label" for="ad-link">Link *</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input id="ad-link" matInput type="text" placeholder="https://" name="link" formControlName="link" required />
              @if (advertisementForm.controls['link'].hasError('url')) {
                <mat-error>Ingresá un link válido que empiece con http:// o https://.</mat-error>
              } @else {
                <mat-error>Ingresá el link.</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="cf-field cf-field--full" [hidden]="isNew()">
            <span class="cf-label">Estado</span>
            <div class="cf-toggles">
              <mat-slide-toggle formControlName="isActive">Activo</mat-slide-toggle>
            </div>
            @if (!advertisementForm.controls.advertisementImg.value) {
              <span class="cf-error">Debe agregar una imagen para poder activar la publicidad</span>
            }
          </div>
          <div class="cf-field cf-field--full" [hidden]="isNew()">
            <app-file-uploader
              [description]="'Imagen de la publicidad'"
              [settings]="uploadersetting"
              [name]="'advertisementImg'"
              (deleteFileEvent)="deleteFileEvent($event)"
              (sendImgsToParent)="syncActiveToggle()"
            ></app-file-uploader>
          </div>
        </div>
        <div class="cf-actions ad-actions">
          <button mat-flat-button id="guardar" type="button" (click)="onSubmit()">
            Guardar
          </button>
        </div>
      </form>
          </div>
        </div>
</section>
